/**
 * Одноразовая передача управления от заставки (#boot-splash в index.html).
 *
 * Заставка живёт ВНЕ #root, чтобы монтирование React её не стирало. Как только
 * вход определился и первый экран нарисован, зовём window.__saleusReady() —
 * заставка гаснет за 250 мс и убирается из дерева.
 */
import { useEffect } from 'react';

let сработало = false;

export function signalBootReady(): void {
  if (сработало) return;
  сработало = true;
  try {
    const fn = window.__saleusReady;
    if (typeof fn === 'function') fn();
  } catch { /* заставка не критична */ }
}

export function useBootReady(ready: boolean): void {
  useEffect(() => {
    if (ready) signalBootReady();
  }, [ready]);
}
